import { EmailType } from "../Enums/EmailEnum";

const PATH = "public-email-subscriptions";

export type PublicEmailSubscriptionsResponse = {
  id: string | null;
  personId: string;
  email: string;
  unsubscribedCategories: EmailType[];
  unsubscribedEventIds?: string[];
  applyCategory?: string | null;
  eventId?: string | null;
};

function apiBase(): string {
  return (process.env.REACT_APP_ROOT_API as string)?.replace(/\/$/, "") || "";
}

async function parseJsonOrThrow(res: Response): Promise<any> {
  const text = await res.text();
  let body: any = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = text;
  }
  if (!res.ok) {
    const message =
      typeof body === "string"
        ? body
        : body?.message || body?.body || res.statusText || "Request failed";
    const err = new Error(String(message));
    (err as any).status = res.status;
    throw err;
  }
  return body;
}

export async function getPublicEmailSubscriptions(
  token: string
): Promise<PublicEmailSubscriptionsResponse> {
  const url = `${apiBase()}/${PATH}?token=${encodeURIComponent(token)}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "x-unsubscribe-token": token,
    },
  });
  return (await parseJsonOrThrow(res)) as PublicEmailSubscriptionsResponse;
}

/** Confirm and apply the one-click unsubscribe encoded in the token. */
export async function applyPublicEmailUnsubscribe(
  token: string
): Promise<PublicEmailSubscriptionsResponse> {
  const url = `${apiBase()}/${PATH}/apply?token=${encodeURIComponent(token)}`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "x-unsubscribe-token": token,
    },
  });
  return (await parseJsonOrThrow(res)) as PublicEmailSubscriptionsResponse;
}

/** Redirect browser through the legacy cid→token bridge (API issues 302). */
export function legacyUnsubscribeBridgeUrl(search: string): string {
  const qs = search.startsWith("?") ? search : search ? `?${search}` : "";
  return `${apiBase()}/${PATH}/legacy${qs}`;
}
